import type { PersistedContact, PersistedContactGroup } from "schemas";

export function filterContacts(contacts: PersistedContact[], contactGroup: PersistedContactGroup) {
  return contacts.filter((contact) => contactGroup.contacts.includes(contact.id.toString()));
}
